import React from "react";
import { Box, Button, HStack, useColorModeValue } from "@chakra-ui/react";
import { ExternalLink, Mail, FileText } from "lucide-react";
import BtechFormModal from "../../pages/BtechFormModal";
import PgFormModal from "../../pages/PgFormModal";

const ContactSection = ({ website, email, brochureLink }) => {
 const bgColor = useColorModeValue("gray.50", "gray.700");
 const hasAnyContact = website || email || brochureLink;

 if (!hasAnyContact) {
  return null;
 }

 return (
  <Box py={5} px={6} bg={bgColor} borderRadius="md" textAlign="center">
   <HStack spacing={4} justifyContent="center" flexWrap="wrap">
    {website && (
     <Button
      leftIcon={<ExternalLink size={18} />}
      colorScheme="blue"
      size="md"
      as="a"
      href={website}
      target="_blank"
      mb={{ base: 2, md: 0 }}
     >
      Visit Website
     </Button>
    )}

    {email && (
     <Button
      leftIcon={<Mail size={18} />}
      colorScheme="teal"
      size="md"
      as="a"
      href={`mailto:${email}`}
      mb={{ base: 2, md: 0 }}
     >
      Contact College
     </Button>
    )}
    <BtechFormModal />
   </HStack>
  </Box>
 );
};

export default ContactSection;
